;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('SageDotCom/Components/Videos/ScoreBrightcoveVideo',["jquery", "eventManager", 'loglevel'], factory) :
        typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require("jquery"), require("eventManager"), require('loglevel')) :
            console && console.error('BrightcoveVideo does not support non-amd script loading.');
}(this/* window */, function ($, eventManager, log) {

    function BrightcoveVideo(scope, stateChangeMessages, onPlayMessagesPerformer, onPauseMessagePerformer, id, allowFullScreen, showCaptioning) {
        ///<summary>Initialize a new instance of Brightcove. Subscribe to messages which are passed to current instance.</summary>

        var self = this, instance = {};
        instance.stateChangeMessages = stateChangeMessages.slice();

        Object.defineProperties(this, {
            $scope: { enumerable: true, value: $(scope) },
            stateChangeMessages: {
                enumerable: true,
                get: function () {
                    return instance.stateChangeMessages.slice();
                }
            },
            player: { enumerable: false, value: videojs(id) },
            isInteractedWithUser: { enumerable: true, configurable: true, writable: true, value: false }
        });

        this.addStateChangeMessage = function addStateChangeMessage(message) {
            if (!message) return;
            if (instance.stateChangeMessages.indexOf(message) > -1) {
                log.debug("Component is already registered for event " + message);
                return;
            }

            instance.stateChangeMessages.push(String(message));
        };

        //#region play message performer
        if (onPlayMessagesPerformer.length) {
            onPlayMessagesPerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.play, self);
            });
        }
        //#endregion

        //#region show messages performer
        if (onPauseMessagePerformer.length) {
            onPauseMessagePerformer.forEach(function (messageName) {
                eventManager.subscribe(messageName, self.pause, self);
            });
        }
        //#endregion

        if (this.stateChangeMessages.length) {
            this.stateChangeMessages.forEach(function (ev) {
                eventManager.trigger(ev, self);
            });
        }

        if (!allowFullScreen) {
            self.$scope.find('.vjs-fullscreen-control').hide();
        }

        if (showCaptioning) {
            this.player.on("loadedmetadata", this._onLoadedMetadataHandler.bind(this));
        }

        var $brightcoveVideo = $(scope).find("video");
        var $brightcoveVideoJSContainer = $(scope).find(".video-js");

        var src = $brightcoveVideo.attr("src");
        if (typeof src === "undefined") {
            //Brightcove won't work as there is no valid src to use
            return;
        }

        // set application id
        var brightcoveApplicationId = "SageDotCom_" + $("html").attr("locale").split("_")[0] + "_" + $("html").attr("id");
        $brightcoveVideo.attr('data-application-id', brightcoveApplicationId);
        $brightcoveVideoJSContainer.attr('data-application-id', brightcoveApplicationId);


        //set up pausing on carousel slide change
        var $carousel = $brightcoveVideo.parents(".carousel");
        $carousel.on('slid.bs.carousel', function (e) {
            self.pause();
        });

        this.player.on("play", this._onPlayHandler.bind(this, $carousel));
        this.player.on("pause", this._onPauseHandler.bind(this, $carousel));
    }

    BrightcoveVideo.prototype._onPlayHandler = function ($carousel) {
        this.isInteractedWithUser = true;

        // pause carousel
        $carousel.carousel("pause");
    }

    BrightcoveVideo.prototype._onPauseHandler = function ($carousel) {
        this.isInteractedWithUser = true;

        // restart carousel cycling
        $carousel.carousel("cycle");
    }

    BrightcoveVideo.prototype._onLoadedMetadataHandler = function () {
        // Get the browser language 
        var browserLanguage = navigator.language || navigator.userLanguage; // IE <= 10;
        browserLanguage = browserLanguage.substr(0, 2);
        // Get the captions
        var trackLanguage;
        var tracks = this.player.textTracks();

        for (var i = 0; i < (tracks.length); i++) {
            trackLanguage = tracks[i].language.substr(0, 2);
            // Set the default caption language
            // When the caption language equals the browser language, then set it as default 
            if (trackLanguage) {
                if (trackLanguage === browserLanguage) {
                    tracks[i].mode = "showing";
                    return;
                } else {
                    tracks[i].mode = "disabled";
                }
            }
        }
    }

    BrightcoveVideo.prototype.play = function () {
        ///<summary>Start playing the video.</summary>

        if (this.isInteractedWithUser) {
            this.player.muted(false);
            this.player.volume(1.0);
        }

        this.player.play();

        this.transmitStateChange();
    }

    BrightcoveVideo.prototype.pause = function () {
        ///<summary>Put the video on pause.</summary>
        this.player.pause();

        this.transmitStateChange();
    }

    BrightcoveVideo.prototype.transmitStateChange = function () {
        var messages = this.stateChangeMessages, self = this;
        if (messages.length) {
            messages.forEach(function (ev) {
                eventManager.trigger(ev, self, self.player);
            });
        }

    }

    BrightcoveVideo.init = function init(args) {
        return args.IsEditorEditing === true
            ? null
            : new BrightcoveVideo(args.scope,
                args.StateChangeMessagesTransmitting || [],
                args.PlayActionMessages || [],
                args.PauseActionMessages || [],
                args.Id,
                args.AllowFullScreen,
                args.ShowCaptioning);
    };

    return BrightcoveVideo;
}));
